import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: navigator.language.slice(0, 2),
  fallbackLocale: 'en', // set fallback locale
  messages: {
    'fr': require('./lang/fr.json'),
    'de': require('./lang/de.json'),
    'en': require('./lang/en.json'),
    'it': require('./lang/it.json'),
    'cn': require('./lang/cn.json')
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js